import { Controller } from "@hotwired/stimulus";
import $ from 'jquery';

export default class extends Controller {
  close() {
    $(this.targets.element).fadeOut();
  }
}

